import { HomeHero } from '../components/sections/HomeHero';
import { HomeStats } from '../components/sections/HomeStats';
import { HomeSubsidies } from '../components/sections/HomeSubsidies';
import { HomeServices } from '../components/sections/HomeServices';
import { HomeWhyUs } from '../components/sections/HomeWhyUs';
import { HomeTestimonials } from '../components/sections/HomeTestimonials';
import { HomeGallery } from '../components/sections/HomeGallery';
import { HomeCTA } from '../components/sections/HomeCTA';

const Home = () => (
  <div>
    <HomeHero />
    <HomeStats />
    <HomeSubsidies />
    <HomeServices />
    <HomeWhyUs />
    <HomeTestimonials />
    <HomeGallery />
    <HomeCTA />
  </div>
);

export default Home;
